<template>
    <div>
        <event-history-mobile/>
    </div>
</template>

<script>
    import {mapGetters } from 'vuex'
    import EventHistoryDesktop from "./EventHistoryDesktop";
    import EventHistoryMobile from "./EventHistoryMobile";


    export default {
        name: "EventHistory",
        components: {EventHistoryMobile, EventHistoryDesktop},
        computed: {
            ...mapGetters( [
                "isMobile"
            ])
        },
    }
</script>

<style scoped>

</style>
